export const ADD_ORDER_FOR_EDIT_DETAILS = "ADD_ORDER_FOR_EDIT_DETAILS"
export const DELETE_ORDER_FOR_EDIT_DETAILS = "DELETE_ORDER_FOR_EDIT_DETAILS"